<template>
  <section class="token-transfer mt-3">
    <h1>Token Transfer</h1>

    <div class="flex gap-2">
      <div class="field-group">
        <input class="input" placeholder="Mint Address" v-model="mint" />
      </div>
      <button
        class="btn btn-solid-primary"
        :disabled="loading"
        @click="onLoad"
      >
        LOAD
      </button>
    </div>

    <div class="card animate__animated animate__fadeIn" v-if="tokenInfo">
      <div class="card-header">
        <TokenImage :mint="mint"></TokenImage>
      </div>
      <div class="card-body">
        <form
          @submit="
            (e) => {
              transferTokens(e);
            }
          "
        >
          <label>To:</label>
          <input
            class="form-control"
            value="text"
            placeholder="Wallet Address"
            v-model="form.destination"
          />

          <label>Amount</label>
          <input
            class="form-control mb-0"
            value="text"
            v-model.number="form.amount"
          />
          <p
            class="text-end"
            @click="
              () => {
                form.amount = balance?.uiAmount;
              }
            "
          >
            Balance: {{ balance?.uiAmount }}
          </p>

          <div class="row my-3">
            <button
              type="submit"
              class="btn btn-solid-primary mt-5 w-50 mx-auto"
            >
              Transfer
            </button>
          </div>
        </form>
      </div>
    </div>
  </section>
</template>

<script>
import { web3 } from "@project-serum/anchor";
import TokenImage from "@/components/common/TokenImage.vue";
import SignatureLoader from "@/mixins/SignatureLoader";

export default {
  name: "TransferView",
  components: { TokenImage },
  mixins: [SignatureLoader],
  data() {
    return {
      loading: false,
      mint: null,
      token: null,
      tokenAccount: null,
      form: {
        destination: "",
        amount: 1,
      },
    };
  },
  computed: {
    tokenInfo: function () {
      return this.token?.data?.parsed?.info;
    },
    balance: function () {
      return this.tokenAccount?.tokenAmount;
    },
  },
  methods: {
    transferTokens: async function (e) {
      e.preventDefault();

      const tokenAmount =
        this.form.amount * Math.pow(10, this.tokenInfo.decimals);

      const srcWallet = new web3.PublicKey(this.$store.state.wallet.address);
      const dstWallet = new web3.PublicKey(this.form.destination);

      let ixs;
      if (this.mint === "So11111111111111111111111111111111111111112") {
        ixs = await this.$store.state.solana.tokenClient
          .getSendTransferSolTransaction(srcWallet, dstWallet, tokenAmount)
          .catch((e) => {
            this.$toastr.e(e, "Transfer failed");
          });
      } else {
        ixs = await this.$store.state.solana.tokenClient
          .getSendTransferTransaction(
            new web3.PublicKey(this.mint),
            srcWallet,
            dstWallet,
            tokenAmount,
            this.tokenInfo.decimals,
            this.token.owner,
            true
          )
          .catch((e) => {
            this.$toastr.e(e, "Transfer failed");
          });
      }

      if (!ixs) return;

      const unitLimit = 40_000;
      const unitPrice = Math.floor(
        this.$store.getters["settings/priorityFee"] / unitLimit
      );

      const txn = new web3.Transaction().add(
        web3.ComputeBudgetProgram.setComputeUnitLimit({ units: unitLimit }),
        web3.ComputeBudgetProgram.setComputeUnitPrice({
          microLamports: unitPrice,
        })
      );
      txn.add(ixs);

      return await this.signAndSendTransaction(txn, "transfer", [], () => {
        this.getBalance();
        setTimeout(() => this.getBalance(), 1000);
      });
    },

    //Note this doesnt support adding wrapped sol but cba to add it at the moment
    getBalance: async function () {
      if (this.mint === "So11111111111111111111111111111111111111112") {
        this.tokenAccount = {
          decimals: 9,
          tokenAmount: {
            amount: 0,
            decimals: 9,
            uiAmount: 0.0,
            uiAmountString: "0",
          },
        };

        const b = await this.$store.state.solana.client.getBalance(
          new web3.PublicKey(this.$store.state.wallet.address)
        );
        if (b) {
          this.tokenAccount.tokenAmount.amount += b;
          this.tokenAccount.tokenAmount.uiAmount += Number(b / Math.pow(10, 9));
          this.tokenAccount.tokenAmount.uiAmountString = `${this.balance.uiAmount}`;
        }
      } else {
        const r =
          await this.$store.state.solana.tokenClient.getUserTokenAccount(
            new web3.PublicKey(this.mint),
            new web3.PublicKey(this.$store.state.wallet.address),
            this.token.owner
          );
        if (r) {
          this.tokenAccount = r.value?.data?.parsed?.info;
        }
      }
    },
    onLoad: function () {
      this.loading = true;
      this.$store.state.solana.tokenClient
        .getToken(new web3.PublicKey(this.mint))
        .then((r) => {
          this.token = r.value;
          this.getBalance();
        })
        .catch((e) => {
          this.$toastr.e(e, "Unable to get token");
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  mounted() {
    if (this.$route.params.id) {
      this.mint = this.$route.params.id;
      this.onLoad();
      return;
    }
    if (this.$route.query.mint) {
      this.mint = this.$route.query.mint;
      this.onLoad();
    }
  },
};
</script>

<style scoped></style>
